// Service worker registration with update detection
// Used by main.tsx and update prompt component

type UpdateCallback = () => void
let updateCallback: UpdateCallback | null = null

export function onNeedRefresh(callback: UpdateCallback): void {
  updateCallback = callback
}

export function updateServiceWorker(): void {
  if (registration?.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  }
}

let registration: ServiceWorkerRegistration | null = null

export async function registerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    console.log('[PWA] Service workers not supported')
    return
  }

  // Only register in production or if explicitly enabled in dev
  if (import.meta.env.DEV && !import.meta.env.VITE_PWA_DEV) {
    console.log('[PWA] Service worker disabled in development')
    return
  }

  try {
    registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      type: 'module'
    })

    console.log('[PWA] Service worker registered:', registration.scope)

    // Check for updates immediately and periodically
    registration.update()
    setInterval(() => registration?.update(), 60 * 60 * 1000) // Check hourly

    // Listen for waiting service worker (update available)
    registration.addEventListener('updatefound', () => {
      const newWorker = registration?.installing
      if (!newWorker) return

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New version available, notify app
          console.log('[PWA] New version available')
          updateCallback?.()
        }
      })
    })

    // Handle controller change (after update applied)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('[PWA] Controller changed, reloading...')
      window.location.reload()
    })

  } catch (error) {
    console.error('[PWA] Registration failed:', error)
  }
}
